import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { space, layout } from "styled-system";

import StyledIcon from "../Interfaces/StyledIcon";

const StyledContainer = styled.div<StyledIcon>`
  display: flex;
  ${space}
  ${layout}
`;

const ExclamationCircleSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "black",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const color = theme.colors[fill] || fill;

  return (
    <StyledContainer {...props}>
      <svg
        width="58"
        height="57"
        viewBox="0 0 58 57"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29 3.78125C42.3672 3.78125 53.4688 14.7695 53.4688 28.25C53.4688 41.8438 42.4805 52.7188 29 52.7188C15.4062 52.7188 4.53125 41.8438 4.53125 28.25C4.53125 14.7695 15.4062 3.78125 29 3.78125ZM29 0.15625C13.4805 0.15625 0.90625 12.8438 0.90625 28.25C0.90625 43.7695 13.4805 56.3438 29 56.3438C44.4062 56.3438 57.0938 43.7695 57.0938 28.25C57.0938 12.8438 44.4062 0.15625 29 0.15625ZM27.6406 13.75C26.8477 13.75 26.2812 14.4297 26.2812 15.2227L27.0742 34.2539C27.0742 34.9336 27.7539 35.5 28.4336 35.5H29.4531C30.1328 35.5 30.8125 34.9336 30.8125 34.2539L31.6055 15.2227C31.6055 14.4297 31.0391 13.75 30.2461 13.75H27.6406ZM29 37.7656C27.1875 37.7656 25.8281 39.2383 25.8281 40.9375C25.8281 42.75 27.1875 44.1094 29 44.1094C30.6992 44.1094 32.1719 42.75 32.1719 40.9375C32.1719 39.2383 30.6992 37.7656 29 37.7656Z"
          fillOpacity="0.5"
        />
      </svg>
    </StyledContainer>
  );
};

export default ExclamationCircleSVG;
